<template>
  <!-- NOTE: 表示箇所に関わらず UA による表示の出し分けは固定の振る舞いのため、コンポーネント自身で出し分けるようにした -->
  <!-- NOTE: Windows / Mac の chrome では最小フォントサイズが 10px となってしまい、8px 指定が効かなくなってしまうため、意図せず崩れてしまいます
             なので iPhone5 / SE の大きさを確認する際は chrome のシミュレーション以外でご確認をお願いします
             https://www.weblab.co.jp/staff/creator/8557.html -->
  <div
    v-if="isShowableAppDownloadLinkPanel"
    class="app-download-link-panel"
    :class="additionalClass"
  >
    <GifteeAppIcon class="app-download-link-panel__giftee-app-icon" />
    <div class="app-download-link-panel-text">
      <p class="app-download-link-panel-text__title">
        giftee公式アプリ（無料）
      </p>
      <p class="app-download-link-panel-text__body">
        ギフトのある生活を、もっと身近に。
      </p>
    </div>
    <a :href="appDownloadLinkUrl" class="app-download-link-panel-link">
      <span class="app-download-link-panel-link__text">ダウンロード</span>
    </a>
  </div>
</template>

<script>
import GifteeAppIcon from '../../atoms/icons/GifteeAppIcon.vue'
export default {
  components: { GifteeAppIcon },
  props: {
    additionalClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      userAgent: ''
    }
  },
  computed: {
    isIPhoneUserAgent() {
      return this.userAgent.indexOf('iPhone') !== -1
    },
    isAndroidUserAgent() {
      return (
        this.userAgent.indexOf('Android') !== -1 &&
        this.userAgent.indexOf('Mobile') !== -1
      )
    },
    isShowableAppDownloadLinkPanel() {
      return this.isIPhoneUserAgent || this.isAndroidUserAgent
    },
    appDownloadLinkUrl() {
      if (this.isIPhoneUserAgent) {
        return 'https://itunes.apple.com/us/app/giftee/id508754185?l=ja&ls=1&pt=999334&ct=footer&mt=8'
      }
      return 'https://play.google.com/store/apps/details?id=co.giftee.app&utm_source=footer'
    }
  },
  mounted() {
    this.userAgent = navigator.userAgent
  }
}
</script>
<style lang="scss" scoped>
.app-download-link-panel {
  padding: 16px;
  box-sizing: border-box;
  max-width: $small-contents-width;
  background-color: $white;
  border: 1px solid $gray-2;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media all and (max-width: $small-contents-width - 1) {
    padding: 16px 14px;
  }

  &__giftee-app-icon {
    height: 44px;
    width: 44px;

    @media all and (max-width: $small-contents-width - 1) {
      height: 40px;
      width: 40px;
    }
  }

  &-text {
    line-height: 2;
    text-align: left;

    &__title {
      font-weight: bold;
      font-size: 1.2rem;

      @media all and (max-width: $small-contents-width - 1) {
        font-size: 1rem;
      }
    }

    &__body {
      font-size: 1rem;

      @media all and (max-width: $small-contents-width - 1) {
        // NOTE: 0.8rem とすると期待したフォントサイズにならなかったため px 指定をしている
        font-size: 8px;
      }
    }
  }

  &-link {
    padding: 8px;
    background-color: $black;
    border-radius: 4px;

    @media all and (max-width: $small-contents-width - 1) {
      padding: 8px 4px;
    }

    &__text {
      font-weight: bold;
      font-size: 1rem;
      line-height: 2;
      color: $white;
    }
  }
}
</style>
